import { PlaySimpleBalanceProps } from './types';
import { StyledPlaySimpleBalance } from './style';
import { formattingNumber } from 'utils';
import { useEffect, useRef } from 'react';

const PlaySimpleBalance = ({
  image,
  amount,
  setBalanceWidth,
  margin,
}: PlaySimpleBalanceProps) => {
  const defaultBalanceQuantityFormat = {
    billionShorthand: false,
    fractionalSeparator: '',
    milSeparator: ' ',
    millionShorthand: false,
    thousandShorthand: false,
  };
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (ref.current) {
      const elementWidth = ref.current.getBoundingClientRect().width;
      setBalanceWidth(elementWidth);
    }
  }, []);

  return (
    <StyledPlaySimpleBalance
      className="playSimple-balance"
      ref={ref}
      style={{ marginLeft: `${margin}px` }}
    >
      {image && (
        <img className="playSimple-balance__img" alt="balance" src={image} />
      )}
      {amount && (
        <div className="playSimple-balance__amount">
          <span>
            {formattingNumber({
              number: amount,
              config: defaultBalanceQuantityFormat,
            })}
          </span>
        </div>
      )}
    </StyledPlaySimpleBalance>
  );
};

export default PlaySimpleBalance;
